import { PencilIcon } from "@heroicons/react/24/solid";
import {
    Typography,
    IconButton,
    Tooltip,
    Chip,
} from "@material-tailwind/react";


const UsersList = ({ key, StudentName, StudentMobile, StudentClass, StudentCity, handleShowUser, value, ifAdmin,ifSuperAdmin }) => {
    return (
        <tr key={key} className="border-b-2 ">
            <td >
                <div className=" flex items-center justify-center">
                    <div className="flex flex-col">
                        <Typography variant="small" color="blue-gray" className="font-normal font-extrabold">
                            {StudentName}
                        </Typography>
                        <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal opacity-70 flex justify-end"
                        >
                            {StudentMobile}
                        </Typography>
                    </div>
                    <div className="w-max">
                        <Chip
                            variant="ghost"
                            size="sm"
                            value={ifSuperAdmin?"Super Admin":ifAdmin?"Admin":"Student"}
                            color={ifSuperAdmin ? "purple" : ifAdmin ? "red" : "blue-gray"}
                        />
                    </div>
                </div>
            </td>
            <td >
                <div className="flex flex-col">
                    <Typography variant="small" color="blue-gray" className="font-normal">
                        {StudentClass}
                    </Typography>
                </div>
            </td>
            <td className=" hidden md:inline-block sm:inline-block lg:inline-block">
                <Typography variant="small" color="blue-gray" className="font-normal">
                    {StudentCity}
                </Typography>
            </td>
            <td >
                <Tooltip content="Edit User">
                    <IconButton
                        variant="text"
                        color="blue-gray"
                        onClick={() => {
                            handleShowUser(value)
                        }}
                    >
                        <PencilIcon className="h-4 w-4" />
                    </IconButton>
                </Tooltip>
            </td>
        </tr>
    );
}

export default UsersList;